const RegisteredAgentTypes = Object.freeze({
  INDIVIDUAL: "1",
  COMPANY: "2",
});

export default RegisteredAgentTypes;
